import apiTrainerResult from '@/api/trainer-result'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getTrainerResultStart: '[trainer result] Get trainer result start',
  getTrainerResultSuccess: '[trainer result] Get trainer result success',
  getTrainerResultFailure: '[trainer result] Get trainer result failure',
}

export const actionTypes = {
  getTrainerResult: '[trainer result] Get trainer result',
}

const mutations = {
  [mutationTypes.getTrainerResultStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getTrainerResultSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainerResultFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getTrainerResult](context) {
    context.commit(mutationTypes.getTrainerResultStart)
    return new Promise((resolve) => {
      apiTrainerResult
        .getTrainersResult()
        .then((response) => {
          context.commit(mutationTypes.getTrainerResultSuccess, response.data)
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getTrainerResultFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
